// config.js

// @ts-nocheck

// ensure env object exists
window.env = window.env || {};

// read env variables from window.env
const {
  REACT_APP_ENV,
  REACT_APP_BASE_URL_PORTAL,
  REACT_APP_BASE_URL_VAULT,
  REACT_APP_BASE_URL_CONFG,
} = window.env;

const env = process.env;

// set env variables on config object
const config = {
  env: REACT_APP_ENV || env.REACT_APP_ENV,
  version: env.REACT_APP_VERSION,
  url: {
    VAULT: REACT_APP_BASE_URL_VAULT || env.REACT_APP_BASE_URL_VAULT,
    CONFG: REACT_APP_BASE_URL_CONFG || env.REACT_APP_BASE_URL_CONFG,
    PORTAL: REACT_APP_BASE_URL_PORTAL || env.REACT_APP_BASE_URL_PORTAL,
  },
  session: {
    INTERVAL: 1000 * 60 * 2, // 2 min
  },
};

export default config;
